"use client";
import { sendGTMEvent } from "@next/third-parties/google";
import { useEffect } from "react";

const GTMPageViewHome = () => {
  useEffect(() => {
    sendGTMEvent({
      event: "home_page",
    });
  }, []);

  return null;
};

export default GTMPageViewHome;
